import type { ContainerProps as BSContainerProps } from 'react-bootstrap'

import PropTypes from 'prop-types'
import { Container as BSContainer } from 'react-bootstrap'
import styled from 'styled-components'

export interface PageContainerProps extends BSContainerProps {
  wide?: boolean
}

const StyledContainer = styled(BSContainer)`
  width: ${({ $wide }) => ($wide ? '920px' : '500px')};
  margin-left: auto;
  margin-right: auto;
  padding-top: 10px;
  padding-bottom: 35px;
  padding-left: 0px;
  padding-right: 0px;
  /* mobile & tablet size */
  @media (max-width: 991px) {
    width: unset;
    padding-left: 0px;
    padding-right: 0px;
    margin-left: 20px;
    margin-right: 20px;
  }
`

export const PageContainer: React.FC<PageContainerProps> = (props: PageContainerProps) => {
  const { wide, children, ...otherProps } = props
  return (
    <StyledContainer {...otherProps} $wide={wide} fluid>
      {children}
    </StyledContainer>
  )
}

PageContainer.propTypes = {
  wide: PropTypes.bool,
}

PageContainer.defaultProps = {
  wide: false,
}
